<template>
    <vue-multiselect
        :value="value"
        :class="stateClass"
        track-by="place_id"
        label="display_name"
        :internal-search="false"
        :options="options"
        :placeholder="placeholder"
        @search-change="handleSearch"
        @input="$emit('input', $event ? $event : null)"
    >
        <div slot="noOptions">
            {{ $t('Type to search') }}
        </div>

        <div slot="noResult">
            {{ $t('No results found') }}
        </div>
    </vue-multiselect>
</template>

<script>
    import {formStateMixin} from 'bootstrap-vue/src/mixins/form-state';
    import VueMultiselect from 'vue-multiselect/src/Multiselect';

    export default {
        name: 'AddressSearch',
        components: {VueMultiselect},
        mixins: [formStateMixin],
        props: {
            value: {
                type: Object,
                default: null
            },
            placeholder: {
                type: String,
                default() {
                    return this.$t('Please select')
                }
            }
        },
        data() {
            return {
                options: [],
                timeout: null
            };
        },
        methods: {
            async handleSearch(query) {
                if (!query) {
                    return;
                }

                if (this.timeout) {
                    clearTimeout(this.timeout);
                    this.timeout = null;
                }

                this.timeout = setTimeout(function() {
                    this.fetchData(query);
                }.bind(this), 300);
            },

            fetchData(query) {
                this.axios.get(
                    'https://nominatim.openstreetmap.org/search.php?q=' + query + '&country=de&format=json&addressdetails=1'
                ).then(({data}) => {
                    this.options = data;
                });

            }
        },
    };
</script>
